export function checkButton(text, url) {
    return (text != '' && url != '');
}